import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmService, NotificationService, Alert, Button, Skeleton } from 'excellence-ui';
import { SupplierContractStore } from '../../stores/supplier-contracts.store';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { SupplierContractsDetailsPage } from '../supplier-contracts-details-page/supplier-contracts-details-page';
import { EditFormSkeleton } from '../../../../shared/components/edit-form-skeleton/edit-form-skeleton';
import { NgIcon } from '@ng-icons/core';
import { SupplierContractDetailsEditForm } from '../../components/supplier-contract-details-edit-form/supplier-contract-details-edit-form';

@Component({
  templateUrl: './supplier-contract-details-general-page.html',
  imports: [
    EditFormSkeleton,
    Alert,
    NgIcon,
    TranslocoPipe,
    Button,
    Skeleton,
    SupplierContractDetailsEditForm,
  ],
})
export class SupplierContractDetailsGeneralPage {
  private router = inject(Router);
  private notificationService = inject(NotificationService);
  private confirmService = inject(ConfirmService);
  private supplierContractStore = inject(SupplierContractStore);
  private translocoService = inject(TranslocoService);

  private detailsPage = inject(SupplierContractsDetailsPage);

  protected supplierContractId = this.detailsPage.supplierContractId;
  protected organizationId = this.detailsPage.organizationId;

  protected supplierContractState = computed(() =>
    this.supplierContractStore.getSingleEntry(this.supplierContractId()),
  );

  protected isDeleteLoading = computed(
    () => this.supplierContractState()?.isDeleteLoading || false,
  );

  protected async onClickDelete() {
    const confirm = await this.confirmService.confirm({
      title: this.translocoService.translate(
        'cockpit.supplierContracts.details.general.deleteConfirmDialog.title',
      ),
      message: this.translocoService.translate(
        'cockpit.supplierContracts.details.general.deleteConfirmDialog.message',
      ),
      mode: 'destructive',
      icon: 'heroTrash',
      confirmButtonText: this.translocoService.translate(
        'cockpit.supplierContracts.details.general.deleteConfirmDialog.confirmButton',
      ),
      cancelButtonText: this.translocoService.translate(
        'cockpit.supplierContracts.details.general.deleteConfirmDialog.cancelButton',
      ),
    });
    if (!confirm) {
      return;
    }
    try {
      await this.supplierContractStore.delete(this.supplierContractId());
      this.notificationService.showSuccess({
        title: this.translocoService.translate(
          'cockpit.supplierContracts.details.general.deleteSuccess',
        ),
      });
      this.router.navigate(['/organizations', this.organizationId(), 'supplier-contracts'], {
        replaceUrl: true,
      });
    } catch (error) {
      console.error('Error deleting supplier-contract:', error);
      this.notificationService.showError({
        title: this.translocoService.translate(
          'cockpit.supplierContracts.details.general.deleteError',
        ),
      });
    }
  }
}
